import { createReducer, createActions } from 'reduxsauce'

// Initial State
export const initialState = {}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        //Async
        startup: null
    },
    {
        prefix: 'SYSTEM_'
    }
)
export const SystemTypes = Types

// Reducers and Handlers
export const handlers = {}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/system.js